"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Region = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _useBraze = require("../../hooks/useBraze");
var _Dynamic = require("./Dynamic");
const _excluded = ["region", "subClassName"],
  _excluded2 = ["region", "className", "subClassName", "noWrapper", "as"];
const TopLevelRegions = [
// 'header',
// 'modal',
// 'banner',
'topRegion', 'main', 'bottomRegion'
// 'footer'
];
const RenderRegionComponents = _ref => {
  let {
      region,
      subClassName = ''
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    bannerCards
  } = (0, _useBraze.useBraze)();
  const isTopLevelRegion = TopLevelRegions.includes(region.id);
  const bannerMap = new Map();
  if (isTopLevelRegion && bannerCards) {
    for (const card of bannerCards) {
      var _card$extras;
      const anchorId = (_card$extras = card.extras) === null || _card$extras === void 0 ? void 0 : _card$extras.anchor_component_id;
      if (anchorId) {
        if (!bannerMap.has(anchorId)) {
          bannerMap.set(anchorId, []);
        }
        bannerMap.get(anchorId).push(card);
      }
    }
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, region.components && region.components.map((component, index) => {
    const componentId = component === null || component === void 0 ? void 0 : component.id;
    let matchingBanners = bannerMap.get(componentId) || null;
    if (matchingBanners) {
      matchingBanners = matchingBanners.sort((a, b) => {
        var _a$extras, _b$extras;
        const aOrder = Number((_a$extras = a.extras) === null || _a$extras === void 0 ? void 0 : _a$extras.order) || 0;
        const bOrder = Number((_b$extras = b.extras) === null || _b$extras === void 0 ? void 0 : _b$extras.order) || 0;
        return aOrder - bOrder;
      });
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: `region-component-${component.id}-${index}`
    }, /*#__PURE__*/_react.default.createElement(_Dynamic.Dynamic, (0, _extends2.default)({
      component: component,
      className: subClassName,
      index: index,
      isTopLevelComponent: isTopLevelRegion,
      banners: matchingBanners
    }, rest)));
  }));
};
const Region = _ref2 => {
  let {
      region,
      className = '',
      subClassName = '',
      noWrapper = false,
      as = 'div'
    } = _ref2,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  if (!region || !region.components) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (!noWrapper) {
    const As = as;
    return /*#__PURE__*/_react.default.createElement(As, {
      className: className
    }, /*#__PURE__*/_react.default.createElement(RenderRegionComponents, (0, _extends2.default)({
      region: region,
      subClassName: subClassName
    }, rest)));
  }
  return /*#__PURE__*/_react.default.createElement(RenderRegionComponents, (0, _extends2.default)({
    region: region,
    subClassName: subClassName
  }, rest));
};
exports.Region = Region;